export default {
  name: 'Card',
  props: ['title', 'subtitle', 'dateText', 'content', 'link'],
};
